import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import '@/assets/scss/main.scss'
import '@/assets/js/polyfill.js'


import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import smoothscroll from "@/assets/js/smoothscroll.js"
smoothscroll.polyfill();

var SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing);

import axios from 'axios'
import VueAxios from 'vue-axios'
axios.defaults.baseURL = process.env.NODE_ENV=='development' ? 'http://rosatom-advent.we-demonstrate2.ru/local/tools/api.php' : '/local/tools/api.php';
Vue.prototype.$locationPath = process.env.NODE_ENV=='development' ? 'http://rosatom-advent.we-demonstrate2.ru/' : window.location.origin+'/'

Vue.use(VueAxios, axios)

import Anchor from '@/directives/anchor.directive.js'
Vue.directive('anchor', Anchor)
import ClickOutside from 'vue-click-outside'
Vue.directive('ClickOutside', ClickOutside)

import Scrollbar  from 'smooth-scrollbar';
window.Scrollbar = Scrollbar;

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);


import Closer from "./components/other/Closer";
Vue.component('app-closer', Closer)

import {i18n} from "./plugins/i18n";

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
